import {
	ResponseParams,
	requestHttpGet,
	requestHttpPost,
	requestHttpPut,
	requestHttpDelete,
	ApiError,
} from './RequestBase';
import { PaymentToken } from 'requests/RequestPayment';

// クライアントトークン取得
export type GetClientTokenResData = {
	paypal_client_token: string;
	merchant_id: string;
};
export const callGetClientTokenApi = async (): Promise<ResponseParams<GetClientTokenResData | ApiError>> => {
	const result: ResponseParams<GetClientTokenResData | ApiError> = await requestHttpGet(`/paypal/clienttoken`);
	return result;
};

// 登録カード情報取得
export type GetSavedCardResData = {
	payment_tokens: PaymentToken[];
};
export const callGetSavedCardApi = async (): Promise<ResponseParams<GetSavedCardResData | ApiError>> => {
	const result: ResponseParams<GetSavedCardResData | ApiError> = await requestHttpGet(`/users/cards`);
	return result;
};

// カード情報登録(createOrderで呼ぶ)
export type RegisterCardResData = {
	paypal_order_id: string;
};
export const callRegisterCardApi = async (): Promise<ResponseParams<RegisterCardResData | ApiError>> => {
	const result: ResponseParams<RegisterCardResData | ApiError> = await requestHttpPost(
		`/users/cards/order/checkout`,
		{},
	);
	return result;
};

// 登録カード情報変更(callRegisterCardApiの後に呼ぶ)
type ChangeCardReqData = {
	paypal_order_id: string;
	payment_tokens_id?: string;
};

type ChangePeriodicPaymentReqData = {
	paypal_order_id?: string;
	periodic_payment_id?: string;
};

export const callChangeCardApi = async (body: ChangeCardReqData): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpPut(`/users/cards`, body);
	return result;
};

export const callChangePeriodicPaymentApi = async (
	body: ChangePeriodicPaymentReqData,
): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpPut(`/users/periodic-payment`, body);
	return result;
};

// 登録カード情報削除(一般)
export const callDeleteSavedCardApi = async (paymentTokenId: string): Promise<ResponseParams<void | ApiError>> => {
	const result: ResponseParams<void | ApiError> = await requestHttpDelete(`/users/cards/${paymentTokenId}`);
	return result;
};

// 支払いクレジットカード情報取得
export type GetPaymentCardResData = {
	brand: string;
	last_digits: string;
};
export const callGetPaymentCardApi = async (
	gidOrderNo: string,
): Promise<ResponseParams<GetPaymentCardResData | ApiError>> => {
	const result: ResponseParams<GetPaymentCardResData | ApiError> = await requestHttpGet(`/order/credit/${gidOrderNo}`);
	return result;
};
